var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":"primary","size":"mini","loading":_vm.loading,"disabled":_vm.disabled||_vm.isDisabled},on:{"click":_vm.clickBtn}},[_vm._v(_vm._s(_vm.isDisabled?_vm.countDown+'s内不可操作':_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }